import { MapPin, Phone, Clock, Mail } from "lucide-react";
import { SHOP } from "@/lib/api";

const items = [
  { Icon: MapPin, label: "Address", value: SHOP.address },
  { Icon: Phone, label: "Phone", value: SHOP.phone, href: `tel:${SHOP.phoneTel}` },
  { Icon: Clock, label: "Hours", value: SHOP.hours },
  { Icon: Mail, label: "Walk-ins", value: "Welcome during business hours" },
];

const Contact = () => {
  return (
    <section id="contact" data-testid="contact-section" className="bg-[#0a0a0a] py-24 lg:py-32 border-t border-[#2e2e2e]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
        <div>
          <div className="flex items-center gap-3 mb-6">
            <div className="h-[2px] w-12 bg-[#e10600]" />
            <span className="font-['Exo_2'] uppercase text-xs tracking-[0.4em] text-[#e10600] font-bold">Get in Touch</span>
          </div>
          <h2 className="font-['Anton'] text-white text-5xl md:text-6xl uppercase leading-[0.95] mb-8">
            Stop by.<br /><span className="text-[#e10600]">Or call us.</span>
          </h2>
          <div className="space-y-6">
            {items.map(({ Icon, label, value, href }) => (
              <div key={label} data-testid={`contact-${label.toLowerCase()}`} className="flex items-start gap-5 border-b border-[#2e2e2e] pb-6">
                <div className="w-12 h-12 bg-[#141414] border border-[#2e2e2e] flex items-center justify-center shrink-0">
                  <Icon className="w-5 h-5 text-[#e10600]" strokeWidth={1.5} />
                </div>
                <div>
                  <div className="font-['Exo_2'] text-[10px] uppercase tracking-[0.3em] text-gray-500 font-bold mb-1">{label}</div>
                  {href ? (
                    <a href={href} className="font-['Anton'] text-white text-2xl uppercase hover:text-[#e10600] transition-colors">{value}</a>
                  ) : (
                    <div className="font-['Anton'] text-white text-2xl uppercase">{value}</div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative min-h-[400px] lg:min-h-full">
          <iframe
            title="Mid Del Auto location"
            data-testid="contact-map"
            src="https://www.google.com/maps?q=411+Foster+Place,+Midwest+City,+OK&output=embed"
            className="w-full h-full min-h-[400px] grayscale border border-[#2e2e2e]"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
          <div className="absolute top-4 left-4 bg-[#e10600] px-4 py-2">
            <div className="font-['Anton'] text-white text-lg uppercase">Mid Del Auto</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
